import { SBase } from '@setvi/shared/components';

import { PdfPreviewContent } from './components';
import type { PdfPreviewContentProps } from './components';

interface PreviewZoomDialogProps extends PdfPreviewContentProps {
  title: string;
  onClose: () => void;
}

/** The print-order zoom dialog: a full-size PDF preview with zoom and pager. */
export const PreviewZoomDialog = ({
  title,
  onClose,
  ...content
}: PreviewZoomDialogProps) => (
  <SBase width="95vw" height="95vh" header={{ title, onClose }}>
    <PdfPreviewContent {...content} />
  </SBase>
);
